import md5 from 'md5';

/**
 * Generates a Gravatar URL from an email.
 * Returns the URL string, or null if no email is provided.
 * Use with `d=404` to get a 404 when no Gravatar exists (handled by img onError).
 */
export const getGravatarUrl = (email: string | undefined): string | null => {
  if (!email) return null;
  const hash = md5(email.trim().toLowerCase());
  return `https://www.gravatar.com/avatar/${hash}?d=404&s=64`;
};
